import { render } from "./UpdateInfoPopup.vue?vue&type=template&id=ef025a44&scoped=true&ts=true"
import script from "./UpdateInfoPopup.vue?vue&type=script&lang=ts"
export * from "./UpdateInfoPopup.vue?vue&type=script&lang=ts"

import "./UpdateInfoPopup.vue?vue&type=style&index=0&id=ef025a44&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef025a44"]])

export default __exports__